import type { HierarchicalLayoutConfig, LayoutDescriptor } from '@ardoq/yfiles';
import type { OnLayoutGraphArgs } from 'tabview/graphComponent/onLayoutGraph';
import { Rect, inside, isCollapsibleGroup } from '@ardoq/graph';
import { zoomToNodeFromCurrentContentRect } from '@ardoq/graph/yfiles';

const isHierarchicLayout = (
  layoutDescriptor: LayoutDescriptor
): layoutDescriptor is LayoutDescriptor & {
  properties: HierarchicalLayoutConfig;
} => layoutDescriptor.name === 'HierarchicalLayout';

const onLayoutGraph =
  (expandedStateChangingGroupId: string | null) =>
  ({ graphComponent, layoutDescriptor }: OnLayoutGraphArgs) => {
    const { contentBounds, viewport, graph } = graphComponent;
    if (viewport.height === 0 || viewport.width === 0) {
      // viewport has no size, which probably means the view was closed.
      return;
    }

    if (!isHierarchicLayout(layoutDescriptor)) {
      return;
    }

    const isFreshLayout = !layoutDescriptor.properties?.fromSketchMode;

    if (isFreshLayout) {
      graphComponent.fitContent();
      return;
    }
    const isFullGraphDisplayed = inside(
      Rect.fromRectLike(contentBounds),
      Rect.fromRectLike(viewport)
    );
    if (isFullGraphDisplayed) {
      return;
    }
    if (expandedStateChangingGroupId) {
      const zoomToGroupNode = graph.nodes.find(
        node =>
          isCollapsibleGroup(node.tag) &&
          node.tag.id === expandedStateChangingGroupId
      );
      if (zoomToGroupNode) {
        zoomToNodeFromCurrentContentRect(zoomToGroupNode, graphComponent);
      }
    }
  };
export { onLayoutGraph };
